import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "../../lib/auth-context";
import { LoadingSpinner } from "./LoadingSpinner";

type AdminGuardProps = {
	children: React.ReactNode;
};

// Admin guard component - redirects non-admins to dashboard
export function AdminGuard({ children }: AdminGuardProps) {
	const { isAuthenticated, isLoading, isAdmin } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (!isLoading && !isAuthenticated) {
			navigate({ to: "/login" });
		} else if (!isLoading && isAuthenticated && !isAdmin) {
			navigate({ to: "/" });
		}
	}, [isLoading, isAuthenticated, isAdmin, navigate]);

	if (isLoading) {
		return <LoadingSpinner />;
	}

	if (!isAuthenticated || !isAdmin) {
		return <LoadingSpinner />; // Show spinner while redirecting
	}

	return <>{children}</>;
}
